(function () {
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var button = form.querySelector('[data-add-button]');
    var priceEl = document.querySelector('[data-price="' + form.dataset.section + '"]');
    var soldOut = button ? button.dataset.soldOut : 'Sold out';
    var addLabel = button ? button.dataset.add : 'Add to cart';

    function current() {
      var chosen = [];
      form.querySelectorAll('fieldset[data-option]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        chosen.push(checked ? checked.value : null);
      });
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
    }

    function update() {
      var v = current();
      if (!v) {
        if (button) { button.disabled = true; button.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price;
      if (button) {
        button.disabled = !v.available;
        button.textContent = v.available ? addLabel : soldOut;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', update);
  });
})();
